import React from 'react';
import { ReportInfoPanel } from '@shared/components/ReportInfoPanel';
import ReportInfoItem from '@shared/components/ReportInfoPanelItem';

/**
 * @typedef {object} DataCorrelationInfoBoxClassificationMetric
 * @property {string} [classificationMetricName]
 * @property {string} [classificationNumerator]
 * @property {string} [classificationDenominator]
 */

/**
 * @typedef {object} DataCorrelationInfoBoxProps
 * @property {DataCorrelationInfoBoxClassificationMetric} [classificationMetric]
 * @property {string} [metricCalculationName]
 * @property {string} [practiceAreaInfo]
 * @property {string} [practiceDescription]
 */

/**
 * @param {DataCorrelationInfoBoxProps} props
 */
const DataCorrelationInfoBox = props => {
  const { classificationMetric, metricCalculationName, practiceAreaInfo, practiceDescription } =
    props;

  return (
    <ReportInfoPanel>
      <ReportInfoItem label={practiceAreaInfo} value={practiceDescription} />
      <ReportInfoItem
        label='Metric Classification Name'
        value={classificationMetric.classificationMetricName}
      />
      <ReportInfoItem label='Metric Calculation' value={metricCalculationName} />
      <ReportInfoItem
        label='Metric Classification Numerator'
        value={classificationMetric.classificationNumerator}
      />
      <ReportInfoItem
        label='Metric Classification Denominator'
        value={classificationMetric.classificationDenominator}
      />
    </ReportInfoPanel>
  );
};

export default DataCorrelationInfoBox;
